import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"

const Icon: FC = (): ReactElement => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="md:translate-y-[1px]"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill={THEME.COLORS.blue[300]} />
        <path
            d="M5.21191 8.07706L6.91572 9.93576L10.788 6.06348"
            stroke={THEME.COLORS.blue[100]}
            strokeLinecap="square"
        />
    </svg>
)

Icon.displayName = "CoachingChatCompletedMatrixIcon"

export { Icon as CoachingChatCompletedMatrixIcon }
